// extracted by mini-css-extract-plugin
module.exports = {"section13":"Section13_section13__pMg0_"};